import { compose } from 'redux';
import { connect } from 'react-redux';
import DialogRegister from '../../../pages/Admin/OrganizerManagement/DialogRegister';
import * as Action from '../../../actions/RegistrationOrganizer';
import withScroll from '../../../common/WithScrollTop';
import {
    GetJobsRequested,
    GetZonesRequested,
    GetCategoryRequest,
    GetOccupationRequest,
    ClearOccupation,
} from '../../../actions/CommonOptions';
import { LogoutRequested } from '../../../actions/Auth';

const mapStateToProps = (state) => {
    const isLoading = state.commonOptions.Options.isFetching
    || state.commonOptions.zones.isFetching
    || state.registrationOrganizer.registrationOrganizer.isFetching;

    return ({
        locale: state.locale.lang.current,
        options: state.commonOptions.Options.data,
        room: state.registrationOrganizer.registrationOrganizer.room,
        successCreate: state.registrationOrganizer.registrationOrganizer.successCreate,
        errors: state.registrationOrganizer.registrationOrganizer.errors,
        jobs: state.commonOptions.jobs.data,
        zones: state.commonOptions.zones.data,
        isAuthorized: state.auth.credential.isAuthorized,
        isLoading,
        occupations: state.commonOptions.occupations.data,
        category: state.commonOptions.category.data,
    });
};

const mapDispatchToProps = (dispatch) => ({
    getInformationRoom: (locale) => {
        dispatch(Action.callApiGetInformationRoom(locale));
    },
    createOrganizer: (locale) => {
        dispatch(Action.callApiCreateOrganizer(locale));
    },
    clearData: () => {
        dispatch(Action.clearCreateOrganizer());
    },
    fetchJobs: (shortName) => {
        dispatch(GetJobsRequested(shortName));
    },
    fetchCategory: (shortName) => {
        dispatch(GetCategoryRequest(shortName));
    },
    fetchEventZones: (shortName) => {
        dispatch(GetZonesRequested(shortName));
    },
    logOut: () => {
        dispatch(LogoutRequested());
    },
    getOccupations: (param) => {
        dispatch(GetOccupationRequest(param));
    },
    clearOccupations: () => {
        dispatch(ClearOccupation());
    },
});

export default compose(
    withScroll,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(DialogRegister);
